export const cacheEnable = () => ({
  type: 'CACHE_ENABLE',
});

export const cacheResult = (cache) => ({
  type: 'CACHE_RESULT',
  ...cache,
});
